export const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL
export const FRONT_BASE_URL = process.env.NEXT_PUBLIC_FRONT_BASE_URL
export const EXTERNAL_BASE_URL = process.env.NEXT_PUBLIC_EXTERNAL_BASE_URL
// UA for server-side (SSG/ISR) fetches, so the backend can tell them apart from real visitors
export const SSR_HEADERS = { 'User-Agent': 'frontend-ssr' }
export const MOCK_API = process.env.NEXT_PUBLIC_MOCK_API === 'true'
export const LANGUAGES = JSON.parse(process.env.NEXT_PUBLIC_LANGUAGES!)
export { brand, BRAND_ID, isHappa, isSais, paymentsEnabled } from '@/config/brand'

export const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID as string

// TODO: replace with the real terms-of-purchase PDF URL
export const TERMS_OF_PURCHASE_URL = 'https://example.com/termini-di-acquisto.pdf'

export const KEY = {
  GF_CONSUMER_KEY: process.env.NEXT_PUBLIC_GF_CONSUMER_KEY,
  GF_CONSUMER_SECRET: process.env.NEXT_PUBLIC_GF_CONSUMER_SECRET
}

export const API = {
  BASE: '/wp-json/wp/v2',
  ROUTES: '/wp-json/gusto/routes',
  STRINGS: '/wp-json/gusto/options',
  MENU_LOCATIONS: '/wp-json/gusto/nav/menu-locations',
  GRAVITY_FORM: '/wp-json/gf/v2/forms',
  SEARCH: '/wp-json/wp/v2/search'
}

export const EXTERNAL_API = {
  BASE: '/api',
  AUTH: {
    REGISTER: '/register',
    LOGIN: '/login',
    REFRESH_TOKEN: '/token/refresh',
    LOGOUT: '/logout',
    FORGOT_PASSWORD: '/forgot-password',
    RESET_PASSWORD: '/reset-password',
    EMAIL_VERIFICATION_NOTIFICATION: '/email/verification-notification',
    EMAIL_VERIFY: '/email/verify'
  },
  STATS_TOKEN: '/stats-token',
  CITIES: '/cities',
  FEATURES: '/features',
  ADVERTISEMENTS: {
    BASE: '/advertisements',
    SEARCH: '/advertisements/search'
  },
  PROPERTIES: {
    BASE: '/properties'
  },
  PROFILE: {
    BASE: '/profile',
    PASSWORD: '/profile/password',
    AVATAR: '/profile/avatar',
    LICENSE: '/profile/license',
    ID_DOCUMENT: '/profile/id-document'
  },
  USERS: {
    BASE: '/users',
    FILTER: '/users/filter'
  },
  POSTS: {
    BASE: '/posts',
    SEARCH: '/posts/search'
  },
  COUNTRIES: '/countries',
  UNIVERSITIES: '/universities',
  COURSES: '/courses',
  CAMPUSES: '/campuses',
  SERVICES_INCLUDED: '/services_included',
  BOOKINGS: '/bookings',
  EXPORTS: '/admin/exports',
  SUPPORT: '/support',
  REPORT: '/report',
  CHAT: {
    CONVERSATIONS: '/chat/conversations',
    MESSAGES: '/chat/messages'
  },
  PAYMENTS: {
    PRODUCTS: '/products',
    ORDERS: '/orders'
  }
}

export const MediaQuery = {
  SMALL: '(max-width: 767px)',
  MEDIUM: '(min-width: 768px)',
  LARGE: '(min-width: 1024px)',
  TOUCH: '(pointer: coarse)',
  POINTER: '(hover: hover) and (pointer: fine)'
}
